import { useTranslation } from 'react-i18next';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20product%20photography%20of%20fashion%20sneakers%20hoodies%20and%20accessories%20scattered%20artistically%20on%20cream%20surface%2C%20soft%20golden%20hour%20natural%20light%2C%20dreamy%20warm%20tones%2C%20editorial%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20elegant%20composition%20with%20negative%20space&width=1600&height=900&seq=cta-bg-01&orientation=landscape"
        alt="Yoybuy Spreadsheet products"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white uppercase tracking-wide leading-[1.1]">
          {t('cta.title')}
        </h2>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-white/80 font-light max-w-2xl mx-auto leading-relaxed">
          {t('cta.subtitle')}
          <br />
          {t('cta.subtitle_line2')}
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 mt-8 md:mt-10 px-8 py-4 bg-foreground-950 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-shopping-bag-line text-lg"></i>
          </span>
          {t('cta.button')}
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-up-line"></i>
          </span>
        </a>
      </div>
    </section>
  );
}